/* @flow */
import * as React from 'react';
import { Container } from 'flux/utils';

import SignInModal from 'auth/components/SignInModal.jsx';
import AuthActions from 'auth/AuthActions';
import Button from 'components/Button.jsx';
import CurrentUser from 'auth/CurrentUser';
import Glyph from 'components/Glyph.jsx';
import { mountModal } from 'lib/modal';
import User from 'entities/User';
import Text from 'components/Text.jsx';
import UserNavigationMenu from 'components/UserNavigationMenu.jsx';

import './styles/HeaderLight.scss';

type Props = {
  hideLogin?: boolean,
  hideLogout?: boolean,

  onLogin: () => void,
  onLogout: () => void,
};

type State = {
  user?: User,
};

class HeaderLight extends React.Component<Props, State> {
  static getStores() {
    return [CurrentUser];
  }

  static calculateState() {
    return {
      user: CurrentUser.isSignedIn() ? CurrentUser.getUser() : undefined,
    };
  }

  onLogin = () => {
    if (this.props.onLogin) {
      this.props.onLogin();
    } else {
      mountModal(<SignInModal />, this);
    }
  };
  onLogout = () => {
    if (this.props.onLogout) {
      this.props.onLogout();
    } else {
      AuthActions.signOut();
    }
  };
  render() {
    const { hideLogout, hideLogin } = this.props;
    const { user } = this.state;

    return (
      <header className="HeaderLight">
        <div className="HeaderLight-brand">Remind</div>
        <div className="HeaderLight-info">
          <Text color="thunder">{this.state.user && this.state.user.getEmail()}</Text>
          {user &&
            !hideLogout && (
              <UserNavigationMenu>
                <Glyph name="chevron-down" color="thunder" className="HeaderLight-info-glyph" />
              </UserNavigationMenu>
            )}
          {!user &&
            !hideLogin && (
              <Button level="secondary" color="thunder" size="xsmall" onClick={this.onLogin}>
                Log in
              </Button>
            )}
        </div>
      </header>
    );
  }
}

export default Container.create(HeaderLight);
